import { ArnHttpService } from '../http';
import { ArnI18nService } from './ArnI18nService';
import { ArnValidI18nConfig } from '@arianee/arn-types';

export class ArnHttpI18nService implements ArnI18nService {
  constructor(
    readonly config: ArnValidI18nConfig,
    protected http: ArnHttpService
  ) {}

  async get<T>(...lang: string[]): Promise<T> {
    return this.http.fetchJson<T>(this.config.url, {
      headers: { ['Accept-Language']: lang.join(',') },
    });
  }
}
